import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useMutation } from "@tanstack/react-query";

const useSendWaiterCordQuery = () => {
  const branchId = useBranchId();
  const query = useMutation({
    mutationFn: ({ lat, lng }: { lat: string; lng: string }) =>
      get2(
        `internal/secure/pos/v1/maps/distance/to/branch/${branchId}/${lat}/${lng}`,
        // A 403 means the waiter is not at the branch, useSendWaiterCord shows that
        { ignoreAccessDenied: true }
      ),
  });

  return query;
};

export default useSendWaiterCordQuery;
